import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { money, fmtDate } from "@/lib/format";
import { StatusBadge } from "@/components/StatusBadge";

export const MyApplications = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/applications/mine").then((r) => setItems(r.data.items)); }, []);
  if (!items?.length) return null;
  return (
    <section className="mt-10" data-testid="my-applications">
      <h2 className="font-display text-2xl font-semibold">My applications</h2>
      <ul className="mt-4 divide-y rounded-lg border bg-card">
        {items.map((a) => (
          <li key={a.id} className="flex flex-col gap-2 px-5 py-4 sm:flex-row sm:items-center sm:justify-between" data-testid={`my-application-${a.id}`}>
            <div className="min-w-0">
              <div className="font-medium">{money(a.amount_cents)} · {a.term_months} months · {a.purpose}</div>
              <div className="text-xs text-muted-foreground">Submitted {fmtDate(a.submitted_at)}{a.loan_number ? ` · Loan ${a.loan_number}` : ""}</div>
              {a.status === "rejected" && <div className="mt-1 text-sm text-destructive" data-testid={`my-application-reason-${a.id}`}>Reason: {a.reject_reason}</div>}
            </div>
            <StatusBadge status={a.status} testid={`my-application-status-${a.id}`} />
          </li>
        ))}
      </ul>
    </section>
  );
};
